var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import _chunk from "lodash/chunk";
import _defaultsDeep from "lodash/defaultsDeep";
import { CUJStatus } from "@pns-fe/monitor";
import { CUJEvents } from "../../constants/cujEvents";
import { ApiVersion, ConsentStatus, ConsentStatusParam } from "../../constants/sdk";
import LoggingModule from "../logging-module";
import ServiceModule from "../service-module";
import StorageModule from "../storage-module";
const DEFAULT_PAGE_SIZE = 100;
const DEFAULT_VERSION = {
  fetch: {
    pageSize: DEFAULT_PAGE_SIZE,
    version: ApiVersion.V2
  },
  update: {
    pageSize: DEFAULT_PAGE_SIZE,
    version: ApiVersion.V2
  }
};
const getAPIMethod = (apiVersion) => {
  if (apiVersion === ApiVersion.V1) {
    return "GET";
  }
  return "POST";
};
const formatUpdateRecordParam = (apiVersion, params) => {
  var _a;
  return {
    consent_records: (_a = params == null ? void 0 : params.filter((param) => param == null ? void 0 : param.key).map((param) => __spreadValues({
      entity_key: param.key,
      flow: param.businessFlow,
      status: ConsentStatusParam[param.status]
    }, param.extra ? { extra: param.extra } : {}))) != null ? _a : []
  };
};
const getMissingEntityKeySet = (apiVersion, params) => {
  return new Set(
    params == null ? void 0 : params.filter((param) => param == null ? void 0 : param.key).map((param) => param.key)
  );
};
class ConsentModule {
  constructor() {
    this.destruct = () => {
      LoggingModule.info("[ConsentModule]: destruct");
    };
  }
  init(config) {
    LoggingModule.info("[ConsentModule]: init");
    const { api } = config != null ? config : {};
    const { consent } = api != null ? api : {};
    this._config = _defaultsDeep({}, consent, DEFAULT_VERSION);
  }
  getRecord(entityKey, userInfo) {
    LoggingModule.info("[ConsentModule]: getRecord", { entityKey, userInfo });
    return StorageModule.getRecord(entityKey, userInfo);
  }
  getEntity(entityKey, userInfo) {
    LoggingModule.info("[ConsentModule]: getEntity", { entityKey, userInfo });
    return StorageModule.getEntity(entityKey, userInfo);
  }
  getRecords(entityKeys, userInfo) {
    LoggingModule.info("[ConsentModule]: getRecords", { entityKeys, userInfo });
    return StorageModule.getRecords(entityKeys, userInfo);
  }
  getEntities(entityKeys, userInfo) {
    LoggingModule.info("[ConsentModule]: getEntities", { entityKeys, userInfo });
    return StorageModule.getEntities(entityKeys, userInfo);
  }
  getEntitiesWithApprovedRecord(entityKeys, userInfo) {
    LoggingModule.info("[ConsentModule]: getEntitiesWithApprovedRecord", { entityKeys, userInfo });
    return StorageModule.getEntities(entityKeys, userInfo).filter(
      (entity) => {
        var _a;
        return ((_a = entity == null ? void 0 : entity.record) == null ? void 0 : _a.status) === ConsentStatus.APPROVE;
      }
    );
  }
  shouldFetch() {
    LoggingModule.info("[ConsentModule]: shouldFetch");
    return true;
  }
  _fetchWithPagination(entityKeys, userInfo, domain, method, version, pageSize, timeout, pageToken, requestConfig) {
    return ServiceModule.sendRequest(
      `${domain}/consent/api/combine/list/${version}`,
      method,
      {
        entity_keys: entityKeys,
        page_size: pageSize,
        page_token: pageToken != null ? pageToken : ""
      },
      __spreadProps(__spreadValues({}, requestConfig), {
        timeout,
        params: __spreadValues({}, userInfo)
      })
    );
  }
  fetch(entityKeys, userInfo) {
    var _a;
    LoggingModule.info("[ConsentModule]: fetch");
    let apiConfig = {};
    if (typeof ((_a = this._config) == null ? void 0 : _a.fetch) === "function") {
      apiConfig = this._config.fetch();
    } else {
      apiConfig = this._config.fetch;
    }
    const { version, pageSize, timeout, domain = "", requestConfig } = apiConfig;
    const method = getAPIMethod(version);
    const responseData = {
      data: {},
      pageSize
    };
    let now = (/* @__PURE__ */ new Date()).getTime();
    const promises = _chunk(entityKeys, pageSize).map((subKeys) => {
      return this._fetchWithPagination(subKeys, userInfo, domain, method, version, pageSize, timeout, "", requestConfig).then((res) => {
        var _a2, _b, _c;
        const { entities, data, status_code: statusCode, extra } = (_a2 = res == null ? void 0 : res.data) != null ? _a2 : {};
        const entityData = (_b = entities != null ? entities : data) != null ? _b : [];
        if (statusCode === 0 && entityData && extra) {
          const entityMap = (_c = entityData == null ? void 0 : entityData.reduce) == null ? void 0 : _c.call(entityData, (map, entity) => {
            const { key } = entity != null ? entity : {};
            if (key) {
              map[key] = entity;
            }
            return map;
          }, {});
          responseData.data = __spreadValues(__spreadValues({}, responseData.data), entityMap);
          if (now < extra.now) {
            now = extra.now;
          }
        } else {
          LoggingModule.error("[ConsentModule]: fetch - invalid response", res);
        }
      }).catch((e) => {
        LoggingModule.error("[ConsentModule]: fetch - fail to fetch", e);
      });
    });
    return Promise.all(promises).then((responses) => {
      var _a2;
      StorageModule.insertConsentData((_a2 = responseData.data) != null ? _a2 : {}, now, userInfo);
      return responseData;
    }).catch((e) => {
      LoggingModule.error("[ConsentModule]: fetch - fail to fetch", e);
    });
  }
  updateRecords(params, userInfo) {
    var _a;
    if ((params == null ? void 0 : params.length) === 0) {
      LoggingModule.error("[ConsentModule]: updateRecords - invalid params", {
        params
      });
      return Promise.reject(new Error("[ConsentModule]: updateRecords - invalid params"));
    }
    LoggingModule.info("[ConsentModule]: updateRecords");
    let apiConfig = {};
    if (typeof ((_a = this._config) == null ? void 0 : _a.update) === "function") {
      apiConfig = this._config.update();
    } else {
      apiConfig = this._config.update;
    }
    const { version, domain = "", timeout, requestConfig } = apiConfig;
    if (version === ApiVersion.V1) {
      const msg = "[ConsentModule]: updateRecords - v1 api is not supported anymore";
      LoggingModule.error(msg, {
        version,
        params
      });
      return Promise.reject(new Error(msg));
    }
    return ServiceModule.sendRequest(
      `${domain}/consent/api/record/create/sync/${version}`,
      "POST",
      formatUpdateRecordParam(version, params),
      __spreadProps(__spreadValues({}, requestConfig != null ? requestConfig : {}), {
        timeout,
        params: __spreadValues({}, userInfo)
      })
    ).then((res) => {
      var _a2, _b, _c, _d;
      const missingEntityKeySet = getMissingEntityKeySet(version, params);
      const { consent_record_ids: consentRecordIds, data = {}, status_code: statusCode, extra } = (_a2 = res == null ? void 0 : res.data) != null ? _a2 : {};
      let newData = {};
      const updatedRecords = (_b = consentRecordIds != null ? consentRecordIds : Object.keys(data != null ? data : {})) != null ? _b : [];
      if (statusCode === 0) {
        newData = (_c = updatedRecords == null ? void 0 : updatedRecords.reduce) == null ? void 0 : _c.call(updatedRecords, (map, recordOrKey) => {
          const record = version === ApiVersion.V1 ? recordOrKey : data[recordOrKey];
          const entityKey = version === ApiVersion.V1 ? record.entity_key : recordOrKey;
          const _a3 = record != null ? record : {}, { record_id: id = "", created_at, business_flow, status: recordStatus } = _a3, rest = __objRest(_a3, ["record_id", "created_at", "business_flow", "status"]);
          if (entityKey) {
            missingEntityKeySet.delete(entityKey);
            const entity = this.getEntity(entityKey, userInfo);
            map[entityKey] = __spreadProps(__spreadValues({}, entity), {
              record: __spreadValues({
                id,
                entity_key: entityKey,
                status: recordStatus,
                created_at: created_at != null ? created_at : extra.now,
                business_flow
              }, rest)
            });
          }
          return map;
        }, {});
        StorageModule.insertConsentData(newData, extra.now, userInfo);
        LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.FINISH, {
          data: newData ? (_d = Object.keys(newData)) == null ? void 0 : _d.map((key) => {
            var _a3, _b2;
            return {
              key,
              status: (_b2 = (_a3 = newData[key]) == null ? void 0 : _a3.record) == null ? void 0 : _b2.status
            };
          }) : []
        });
      } else {
        LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.FAILURE, {
          error: new Error("[ConsentModule]: updateRecords - invalid response")
        });
        LoggingModule.error("[ConsentModule]: updateRecords - invalid response", {
          statusCode
        });
      }
      if (missingEntityKeySet.size) {
        LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.FAILURE, {
          error: new Error("[ConsentModule]: updateRecords - fail to create records for certain entities")
        });
        LoggingModule.info("[ConsentModule]: updateRecords - fail to create records for certain entities", {
          keys: [...missingEntityKeySet]
        });
      }
      return newData;
    }).catch((e) => {
      LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.FAILURE, {
        error: e
      });
      LoggingModule.error("[ConsentModule]: updateRecords - fail to create records", e);
      throw e;
    });
  }
}
var ConsentModule_default = ConsentModule;
export {
  DEFAULT_PAGE_SIZE,
  DEFAULT_VERSION,
  ConsentModule_default as default
};
